import PropTypes from 'prop-types';
import React, { Component } from 'react';
import './index.scss';
import { GeckoField, GECKO_CONSTS, GeckoBtn } from 'ui';

class TimePicker extends Component {
  static propTypes = {
    value: PropTypes.number,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    value: null,
    onChange: () => {},
  };

  parseValue() {
    if (this.props.value === undefined || this.props.value === null) {
      return { hour: null, minute: null };
    }
    return {
      hour: Math.floor(this.props.value / 3600),
      minute: Math.floor((this.props.value % 3600) / 60),
    };
  }

  buildValue(value) {
    return value.hour * 3600 + value.minute * 60;
  }

  handleFieldChange(key, val) {
    const newValue = this.buildValue(
      Object.assign({}, this.parseValue(), { [key]: val })
    );
    this.props.onChange(newValue);
  }

  setNow() {
    const now = new Date();
    this.props.onChange(
      this.buildValue({ hour: now.getHours(), minute: now.getMinutes() })
    );
  }

  render() {
    const hourField = {
      key: 'hour',
      placeholder: 'HH',
      type: GECKO_CONSTS.FIELD_TYPE_SELECT,
      options: [
        { label: '00', value: 0 },
        { label: '01', value: 1 },
        { label: '02', value: 2 },
        { label: '03', value: 3 },
        { label: '04', value: 4 },
        { label: '05', value: 5 },
        { label: '06', value: 6 },
        { label: '07', value: 7 },
        { label: '08', value: 8 },
        { label: '09', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 },
        { label: '13', value: 13 },
        { label: '14', value: 14 },
        { label: '15', value: 15 },
        { label: '16', value: 16 },
        { label: '17', value: 17 },
        { label: '18', value: 18 },
        { label: '19', value: 19 },
        { label: '20', value: 20 },
        { label: '21', value: 21 },
        { label: '22', value: 22 },
        { label: '23', value: 23 },
      ],
    };
    const minuteField = {
      key: 'minute',
      placeholder: 'MM',
      type: GECKO_CONSTS.FIELD_TYPE_SELECT,
      options: [
        { label: '00', value: 0 },
        { label: '01', value: 1 },
        { label: '02', value: 2 },
        { label: '03', value: 3 },
        { label: '04', value: 4 },
        { label: '05', value: 5 },
        { label: '06', value: 6 },
        { label: '07', value: 7 },
        { label: '08', value: 8 },
        { label: '09', value: 9 },
        { label: '10', value: 10 },
        { label: '11', value: 11 },
        { label: '12', value: 12 },
        { label: '13', value: 13 },
        { label: '14', value: 14 },
        { label: '15', value: 15 },
        { label: '16', value: 16 },
        { label: '17', value: 17 },
        { label: '18', value: 18 },
        { label: '19', value: 19 },
        { label: '20', value: 20 },
        { label: '21', value: 21 },
        { label: '22', value: 22 },
        { label: '23', value: 23 },
        { label: '24', value: 24 },
        { label: '25', value: 25 },
        { label: '26', value: 26 },
        { label: '27', value: 27 },
        { label: '28', value: 28 },
        { label: '29', value: 29 },
        { label: '30', value: 30 },
        { label: '31', value: 31 },
        { label: '32', value: 32 },
        { label: '34', value: 34 },
        { label: '35', value: 35 },
        { label: '36', value: 36 },
        { label: '37', value: 37 },
        { label: '38', value: 38 },
        { label: '39', value: 39 },
        { label: '40', value: 40 },
        { label: '41', value: 41 },
        { label: '42', value: 42 },
        { label: '43', value: 43 },
        { label: '44', value: 44 },
        { label: '45', value: 45 },
        { label: '46', value: 46 },
        { label: '47', value: 47 },
        { label: '48', value: 48 },
        { label: '49', value: 49 },
        { label: '50', value: 50 },
        { label: '51', value: 51 },
        { label: '52', value: 52 },
        { label: '53', value: 53 },
        { label: '54', value: 54 },
        { label: '55', value: 55 },
        { label: '56', value: 56 },
        { label: '57', value: 57 },
        { label: '58', value: 58 },
        { label: '59', value: 59 },
      ],
    };

    return (
      <div className="TimePicker">
        <GeckoField
          field={hourField}
          values={this.parseValue()}
          handler={this.handleFieldChange.bind(this)}
        />
        <span className="TimePicker-seperator">:</span>
        <GeckoField
          field={minuteField}
          values={this.parseValue()}
          handler={this.handleFieldChange.bind(this)}
        />
        <GeckoBtn
          name="Now"
          icon="far fa-clock"
          handler={this.setNow.bind(this)}
        />
      </div>
    );
  }
}

export default TimePicker;
